import { render, staticRenderFns } from "./RewardsCode.vue?vue&type=template&id=9b2b7272&scoped=true"
import script from "./RewardsCode.vue?vue&type=script&lang=js"
export * from "./RewardsCode.vue?vue&type=script&lang=js"
import style0 from "./RewardsCode.vue?vue&type=style&index=0&id=9b2b7272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2b7272",
  null
  
)

export default component.exports